/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {ApexOptions} from 'apexcharts'
import Chart from 'react-apexcharts'
import {GET, POST} from '../../../../services/api'
import {Input} from '../../../../components/Input/Input'
import {floatToPrice} from '../../../../functions/price'
import {Button} from '../../../../components/Button/Button'
import {Loading} from '../../../../components/Loading/Loading'
import moment from 'moment'
import {i18n} from '../../../../translate/i18n'
import styles from './index.module.css'
import {toMoney} from '../../../../utils/formater'
import {calcPercent} from '../../../../utils/utils'

type FilterItemType = {
  id: number
  name: string
}

type SalesByCategoryType = {
  label: string
  value: number
}

type SalesByCustomerType = {
  idCustomer: number
  customerName: string
  orders: string
  carts: string
  total: string
}

type SalesSellerType = {
  labels: string[]
  values: number[]
}

type SalesBySellerType = {
  title: string
  labels: string[]
  values: number[]
}

type SelectType = {
  value: string | number
  label: string
}

const GerenteLojaContent: FC = () => {
  const [startDate, setStartDate] = useState('')
  const [finalDate, setFinalDate] = useState('')

  const [customers, setCustomers] = useState<FilterItemType[]>([{id: 0, name: 'Todos'}])
  const [categories, setCategories] = useState<FilterItemType[]>([{id: 0, name: 'Todos'}])
  const [products, setProducts] = useState<FilterItemType[]>([{id: 0, name: 'Todos'}])

  const [customerSelected, setCustomerSelected] = useState<SelectType>({
    value: 0,
    label: 'Todos',
  })
  const [productSelected, setProductSelected] = useState<SelectType>({
    value: 0,
    label: 'Todos',
  })
  const [categorySelected, setCategorySelected] = useState<SelectType>({
    value: 0,
    label: 'Todos',
  })

  const [searchSellers, setSearchSellers] = useState<SelectType[]>([])

  const [sellers, setSellers] = useState<FilterItemType[]>([])

  const [salesByCategory, setSalesByCategory] = useState<SalesByCategoryType[]>([])

  const [sales, setSales] = useState(0)
  const [orders, setOrders] = useState(0)
  const [customersReport, setCustomersReport] = useState(0)
  const [carts, setCarts] = useState(0)
  const [conversion, setConversion] = useState(0)
  const [averageTicket, setAverageTicket] = useState(0)
  const [activeSellers, setActiveSellers] = useState(0)
  const [accesses, setAccesses] = useState(0)

  const [modeViewSale, setModeViewSale] = useState<'daily' | 'monthly'>('daily')
  const [salesSeller, setSalesSeller] = useState<SalesSellerType>({
    labels: [],
    values: [],
  })

  const [modeViewSaleCart, setModeViewSaleCart] = useState<'daily' | 'monthly'>('daily')
  const [salesSellerCart, setSalesSellerCart] = useState<SalesSellerType>({
    labels: [],
    values: [],
  })
  const [salesSellerLink, setSalesSellerLink] = useState<SalesSellerType>({
    labels: [],
    values: [],
  })

  const [salesBySeller, setSalesBySeller] = useState<SalesBySellerType[]>([])
  const [modeViewSalesBySeller, setModeViewSalesBySeller] = useState<'daily' | 'monthly'>('daily')

  const [salesByCustomer, setSalesByCustomer] = useState<SalesByCustomerType[]>([])

  const [dateSearch, setDateSearch] = useState('custom')

  const [loading, setLoading] = useState(false)

  const optionsChart: ApexOptions = {
    chart: {
      height: 350,
      type: 'line',
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
      width: 2,
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6,
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return 'R$' + value.toFixed(2).replace('.', ',')
        },
      },
    },
  }

  const filterSales = async (newStartDate?: string, newFinalDate?: string) => {
    try {
      const salesCategoryRes = await POST('/summaryManagementSeller/sellerCategory', {
        startDate: newStartDate ? newStartDate : startDate,
        endDate: newStartDate ? newFinalDate : finalDate,
        idProduct: productSelected.value,
        idCategory: categorySelected.value,
        idCustomer: customerSelected.value,
        idsSellers: searchSellers.map((seller) => seller.value),
      })
      if (salesCategoryRes.data && salesCategoryRes.data.entities) {
        setSalesByCategory(
          salesCategoryRes.data.entities.map((entity: any) => ({
            label: entity.nameCategory,
            value: parseFloat(entity.Total),
          }))
        )
      } else {
        setSalesByCategory([])
      }

      const salesSellerRes = await POST('/summaryManagementSeller/sellerBillingManager', {
        startDate: newStartDate ? newStartDate : startDate,
        endDate: newStartDate ? newFinalDate : finalDate,
        idProduct: productSelected.value,
        idCategory: categorySelected.value,
        idCustomer: customerSelected.value,
        idsSellers: searchSellers.map((seller) => seller.value),
      })
      if (salesSellerRes.data && salesSellerRes.data.entities && salesSellerRes.data.entities[0]) {
        const itemBilling = salesSellerRes.data.entities[0]
        setSales(parseFloat(itemBilling.total))
        setOrders(parseInt(itemBilling.orders))
        setCarts(parseFloat(itemBilling.carts))
        setConversion(calcPercent(parseFloat(itemBilling.total), parseFloat(itemBilling.carts)))
        setCustomersReport(parseInt(itemBilling.customers))
        setActiveSellers(parseInt(itemBilling.sellers))
        setAverageTicket(parseFloat(itemBilling.average))
        setAccesses(
          parseInt(salesSellerRes.data.countAccesses ? salesSellerRes.data.countAccesses : '0')
        )
      } else {
        setSales(0)
        setOrders(0)
        setCustomersReport(0)
        setCarts(0)
        setConversion(0)
        setAverageTicket(0)
      }

      const salesCustomerRes = await POST('/summaryManagementSeller/sellerCustomer', {
        startDate: newStartDate ? newStartDate : startDate,
        endDate: newStartDate ? newFinalDate : finalDate,
        idProduct: productSelected.value,
        idCategory: categorySelected.value,
        idCustomer: customerSelected.value,
        idsSellers: searchSellers.map((seller) => seller.value),
      })
      if (salesCustomerRes.data && salesCustomerRes.data.entities) {
        setSalesByCustomer(salesCustomerRes.data.entities)
      } else {
        setSalesByCustomer([])
      }

      const salesDateRes = await POST('/summaryManagementSeller/salesDate', {
        startDate: newStartDate ? newStartDate : startDate,
        endDate: newStartDate ? newFinalDate : finalDate,
        idProduct: productSelected.value,
        idCategory: categorySelected.value,
        idCustomer: customerSelected.value,
        idsSellers: searchSellers.map((seller) => seller.value),
      })
      if (salesDateRes.data && salesDateRes.data.entities) {
        setSalesSeller({
          labels: salesDateRes.data.entities.map((entity: any) => entity.day.toLowerCase()),
          values: salesDateRes.data.entities.map((entity: any) => parseFloat(entity.total)),
        })
      } else {
        setSalesSeller({
          labels: [],
          values: [],
        })
      }

      const salesDateCartRes = await POST('/summaryManagementSeller/salesCart', {
        startDate: newStartDate ? newStartDate : startDate,
        endDate: newStartDate ? newFinalDate : finalDate,
        idProduct: productSelected.value,
        idCategory: categorySelected.value,
        idCustomer: customerSelected.value,
        idsSellers: searchSellers.map((seller) => seller.value),
      })

      if (salesDateCartRes.data && salesDateCartRes.data.entities) {
        setSalesSellerCart({
          labels: salesDateCartRes.data.entities.map((entity: any) => entity.day.toLowerCase()),
          values: salesDateCartRes.data.entities.map((entity: any) => parseFloat(entity.carts)),
        })
        setSalesSellerLink({
          labels: salesDateCartRes.data.entities.map((entity: any) => entity.day.toLowerCase()),
          values: salesDateCartRes.data.entities.map((entity: any) => parseFloat(entity.links)),
        })
      } else {
        setSalesSellerCart({
          labels: [],
          values: [],
        })
        setSalesSellerLink({
          labels: [],
          values: [],
        })
      }

      const salesBySellerRes = await POST('/summaryManagementSeller/salesBySeller', {
        startDate: newStartDate ? newStartDate : startDate,
        endDate: newStartDate ? newFinalDate : finalDate,
        idProduct: productSelected.value,
        idCategory: categorySelected.value,
        idCustomer: customerSelected.value,
        idsSellers: searchSellers.map((seller) => seller.value),
      })
      if (salesBySellerRes.data && salesBySellerRes.data.entities) {
        setSalesBySeller(salesBySellerRes.data.entities)
      } else {
        setSalesBySeller([])
      }
    } catch (e) {
      console.log(e)
    }
  }

  const getItems = async () => {
    try {
      setLoading(true)
      const filterItens = await GET('/summaryManagementSeller/infosToFilterManager')
      if (filterItens.data) {
        setCategories(
          filterItens.data.categories
            ? [...categories, ...filterItens.data.categories]
            : [{id: 0, name: 'Todos'}]
        )
        setProducts(
          filterItens.data.products
            ? [...products, ...filterItens.data.products]
            : [{id: 0, name: 'Todos'}]
        )
        setCustomers(
          filterItens.data.customers
            ? [...customers, ...filterItens.data.customers]
            : [{id: 0, name: 'Todos'}]
        )
        setSellers(filterItens.data.sellers ? [...sellers, ...filterItens.data.sellers] : [])
        setSearchSellers(
          filterItens.data.sellers
            ? [...sellers, ...filterItens.data.sellers].map((seller) => ({
                label: seller.name,
                value: seller.id,
              }))
            : []
        )
      }
      await filterSales(moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'))
      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  const verifyModeViewLabels = (sales: SalesSellerType, modeView: string) => {
    if (modeView === 'daily') {
      return sales.labels.map(
        (l) => l.split(' ')[0] + ' ' + i18n.t(`months.${l.split(' ')[1]}`) + ' ' + l.split(' ')[2]
      )
    } else {
      return organizeMonth(sales).labels.map(
        (l) => i18n.t(`months.${l.split(' ')[0]}`) + ' ' + l.split(' ')[1]
      )
    }
  }

  const verifyModeViewValues = (sales: SalesSellerType, modeView: string) => {
    if (modeView === 'daily') {
      return sales.values
    } else {
      return organizeMonth(sales).values
    }
  }

  const organizeMonth = (sales: SalesSellerType) => {
    const newSales: any = {}
    sales.labels.forEach((label, index) => {
      const labelSplit = label.split(' ')
      if (labelSplit.length >= 3) {
        const labelMonth = `${labelSplit[1]} ${labelSplit[2]}`
        if (newSales[labelMonth]) {
          newSales[labelMonth] += sales.values[index]
        } else {
          newSales[labelMonth] = sales.values[index]
        }
      }
    })
    const newSalesResult = Object.entries(newSales).map((sale: any) => ({
      labels: sale[0],
      values: Math.trunc(sale[1] * 100) / 100,
    }))
    return {
      labels: newSalesResult.map((sale) => sale.labels),
      values: newSalesResult.map((sale) => sale.values),
    }
  }

  const changeDateDifference = async (typeDate: string) => {
    setDateSearch(typeDate)
    const formatDate = (date: Date) => date.toISOString().split('T')[0]
    const currentDate = new Date()
    switch (typeDate) {
      case 'today':
        const newStartDate = moment().format('YYYY-MM-DD')
        const newFinalDate = moment().format('YYYY-MM-DD')
        setStartDate(newStartDate)
        setFinalDate(newFinalDate)

        setLoading(true)
        await filterSales(newStartDate, newFinalDate)
        setLoading(false)
        break
      case 'month':
        const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)
        const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0)

        setStartDate(formatDate(firstDayOfMonth))
        setFinalDate(formatDate(lastDayOfMonth))

        setLoading(true)
        await filterSales(formatDate(firstDayOfMonth), formatDate(lastDayOfMonth))
        setLoading(false)
        break
      case 'lastMonth':
        const firstDayOfLastMonth = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth() - 1,
          1
        )
        const lastDayOfLastMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0)

        setStartDate(formatDate(firstDayOfLastMonth))
        setFinalDate(formatDate(lastDayOfLastMonth))

        setLoading(true)
        await filterSales(formatDate(firstDayOfLastMonth), formatDate(lastDayOfLastMonth))
        setLoading(false)
        break
      case 'week':
        const firstDayOfWeek = new Date(currentDate)
        firstDayOfWeek.setDate(currentDate.getDate() - currentDate.getDay())

        const lastDayOfWeek = new Date(currentDate)
        lastDayOfWeek.setDate(currentDate.getDate() + (6 - currentDate.getDay()))

        setStartDate(formatDate(firstDayOfWeek))
        setFinalDate(formatDate(lastDayOfWeek))

        setLoading(true)
        await filterSales(formatDate(firstDayOfWeek), formatDate(lastDayOfWeek))
        setLoading(false)
        break
      case 'lastWeek':
        const lastDayOfLastWeek = new Date(currentDate)
        lastDayOfLastWeek.setDate(currentDate.getDate() - currentDate.getDay() - 1)
        const firstDayOfLastWeek = new Date(lastDayOfLastWeek)
        firstDayOfLastWeek.setDate(lastDayOfLastWeek.getDate() - 6)
        setStartDate(formatDate(firstDayOfLastWeek))
        setFinalDate(formatDate(lastDayOfLastWeek))

        setLoading(true)
        await filterSales(formatDate(firstDayOfLastWeek), formatDate(lastDayOfLastWeek))
        setLoading(false)
        break
      case 'year':
        const firstDayOfYear = new Date(currentDate.getFullYear(), 0, 1)
        const lastDayOfYear = new Date(currentDate.getFullYear(), 11, 31)
        setStartDate(formatDate(firstDayOfYear))
        setFinalDate(formatDate(lastDayOfYear))

        setLoading(true)
        await filterSales(formatDate(firstDayOfYear), formatDate(lastDayOfYear))
        setLoading(false)
        break
      case 'lastYear':
        const firstDayOfLastYear = new Date(currentDate.getFullYear() - 1, 0, 1)
        const lastDayOfLastYear = new Date(currentDate.getFullYear() - 1, 11, 31)
        setStartDate(formatDate(firstDayOfLastYear))
        setFinalDate(formatDate(lastDayOfLastYear))

        setLoading(true)
        await filterSales(formatDate(firstDayOfLastYear), formatDate(lastDayOfLastYear))
        setLoading(false)
        break
    }
  }

  useEffect(() => {
    setStartDate(moment().format('YYYY-MM-DD'))
    setFinalDate(moment().format('YYYY-MM-DD'))
    getItems()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='d-flex justify-content-between gap-5'>
            <div className='card card-xxl-stretch mb-5 mb-xl-12 w-100'>
              <div className='card-body'>
                <div className={styles.filterItems}>
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    placeholder='Selecione um tipo'
                    label={i18n.t(`indicators.customer`)}
                    options={customers.map((item) => ({
                      select: item.name,
                      value: item.id,
                    }))}
                    search
                    value={customerSelected}
                    change={(value: SelectType) => {
                      setCustomerSelected(value)
                    }}
                  />
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    placeholder='Selecione um tipo'
                    label={i18n.t(`indicators.categories`)}
                    options={categories.map((item) => ({
                      select: item.name,
                      value: item.id,
                    }))}
                    search
                    value={categorySelected}
                    change={(value: SelectType) => {
                      setCategorySelected(value)
                    }}
                  />
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    placeholder='Selecione um tipo'
                    label={i18n.t(`indicators.product`)}
                    options={products.map((item) => ({
                      select: item.name,
                      value: item.id,
                    }))}
                    search
                    value={productSelected}
                    change={(value: SelectType) => {
                      setProductSelected(value)
                    }}
                  />
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    search
                    isMulti
                    label={i18n.t(`indicators.sellers`)}
                    placeholder=''
                    options={sellers.map((seller) => ({
                      value: seller.id,
                      select: seller.name,
                    }))}
                    value={searchSellers}
                    change={(selectedSeller: SelectType[]) => {
                      setSearchSellers(selectedSeller)
                    }}
                  />
                </div>
                <div className={styles.filterItemsDate}>
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    placeholder=''
                    label=''
                    options={[
                      {
                        select: 'Hoje',
                        value: 'today',
                      },
                      {
                        select: 'Semana',
                        value: 'week',
                      },
                      {
                        select: 'Semana passada',
                        value: 'lastWeek',
                      },
                      {
                        select: 'Mês',
                        value: 'month',
                      },
                      {
                        select: 'Mês passado',
                        value: 'lastMonth',
                      },
                      {
                        select: 'Ano',
                        value: 'year',
                      },
                      {
                        select: 'Ano passado',
                        value: 'lastYear',
                      },
                      {
                        select: 'Customizado',
                        value: 'custom',
                      },
                    ]}
                    value={dateSearch}
                    change={(value: string) => {
                      changeDateDifference(value)
                    }}
                  />
                  <div
                    className='d-flex gap-2 flex-row align-items-end'
                    style={{marginLeft: '0.5rem'}}
                  >
                    <p>Defina as datas</p>
                    <Input
                      inputAttr={{
                        type: 'date',
                      }}
                      value={startDate}
                      maxLength={finalDate}
                      change={(value: string) => {
                        setDateSearch('custom')
                        setStartDate(value)
                      }}
                    />
                    <p>até</p>
                    <Input
                      inputAttr={{
                        type: 'date',
                      }}
                      label=''
                      value={finalDate}
                      change={(value: string) => {
                        setDateSearch('custom')
                        setFinalDate(value)
                      }}
                    />
                  </div>
                  <Button
                    color='primary'
                    icon='fa fa-filter'
                    text={i18n.t(`buttons.filter`)}
                    click={async () => {
                      setLoading(true)
                      await filterSales()
                      setLoading(false)
                    }}
                    btnClass='fw-bolder'
                    verticalPadding={3}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-between gap-5 flex-wrap'>
            <div className='d-flex flex-row flex-wrap' style={{flex: 0.4}}>
              <div className='d-flex justify-content-between gap-5' style={{flex: 1}}>
                <div className='card mb-5 w-100'>
                  <div className='card-header'>
                    <h3 className='card-title align-items-start flex-column'>
                      <span className='card-label fw-bolder fs-3 mb-1'>
                        {i18n.t(`indicators.summary_store`)}
                      </span>
                    </h3>
                  </div>
                  <div className='card-body'>
                    <div className={styles.cardsItems}>
                      <div className={styles.cardOrders}>
                        <svg
                          width='18'
                          height='13'
                          viewBox='0 0 18 13'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M1.10938 3.19531L2.23047 0.925781C2.3125 0.761719 2.50391 0.652344 2.69531 0.679688L9.39453 1.5L7.09766 5.30078C6.90625 5.65625 6.49609 5.82031 6.11328 5.71094L1.65625 4.42578C1.10938 4.28906 0.863281 3.6875 1.10938 3.19531ZM9.39453 1.5L16.0664 0.679688C16.2578 0.652344 16.4492 0.734375 16.5312 0.925781L17.6523 3.19531C17.8984 3.6875 17.6523 4.28906 17.1055 4.42578L12.6484 5.71094C12.2656 5.82031 11.8555 5.65625 11.6641 5.30078L9.39453 1.5ZM9.33984 3.25H9.42188H9.33984ZM15.082 5.92969L16.3945 5.54688V10.1133C16.3945 10.7148 15.9844 11.2344 15.3828 11.3984L9.80469 12.793C9.53125 12.8477 9.23047 12.8477 8.95703 12.793L3.37891 11.3984C2.80469 11.2344 2.39453 10.7148 2.39453 10.1133V5.54688L3.70703 5.92969V10.1133L8.73828 11.3711V4.78125C8.73828 4.42578 9.01172 4.125 9.39453 4.125C9.75 4.125 10.0508 4.42578 10.0508 4.78125V11.3711L15.082 10.1133V5.92969Z'
                            fill='#37393D'
                          />
                        </svg>
                        <p>{i18n.t(`indicators.orders`)}</p>
                        <div className='d-flex flex-row align-items-center gap-2'>
                          <h4>{orders}</h4>
                        </div>
                      </div>
                      <div className={styles.cardOrders}>
                        <svg
                          width='15'
                          height='15'
                          viewBox='0 0 15 15'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M5.0625 3.15625C5.0625 3.18359 5.0625 3.18359 5.0625 3.21094C5.08984 3.23828 5.11719 3.29297 5.19922 3.34766C5.19922 3.375 5.22656 3.375 5.22656 3.375C4.70703 3.40234 4.21484 3.42969 3.75 3.51172V3.15625C3.75 2.66406 3.99609 2.28125 4.32422 2.00781C4.625 1.70703 5.03516 1.48828 5.5 1.32422C6.42969 0.96875 7.66016 0.75 9 0.75C10.3125 0.75 11.543 0.96875 12.4727 1.32422C12.9375 1.48828 13.3477 1.70703 13.6484 2.00781C13.9766 2.28125 14.25 2.66406 14.25 3.15625V6V8.84375C14.25 9.33594 13.9766 9.74609 13.6484 10.0195C13.3477 10.293 12.9375 10.5391 12.4727 10.7031C12.1992 10.8125 11.9258 10.8945 11.625 10.9766V9.60938C11.7617 9.58203 11.8711 9.52734 12.0078 9.47266C12.3633 9.33594 12.6367 9.17188 12.7734 9.0625C12.8555 8.98047 12.8828 8.92578 12.9102 8.89844C12.9375 8.87109 12.9375 8.87109 12.9375 8.87109V7.66797C12.7734 7.72266 12.6367 7.80469 12.4727 7.85938C12.1992 7.96875 11.9258 8.05078 11.625 8.13281V6.76562C11.7617 6.73828 11.8711 6.68359 12.0078 6.62891C12.3633 6.49219 12.6367 6.32812 12.7734 6.21875C12.8555 6.13672 12.8828 6.08203 12.9102 6.05469C12.9375 6.02734 12.9375 6.02734 12.9375 6.02734V4.82422C12.7734 4.87891 12.6367 4.96094 12.4727 5.01562C12.0898 5.15234 11.6797 5.28906 11.2148 5.37109C11.0781 5.15234 10.9141 4.98828 10.75 4.85156C10.4766 4.60547 10.1484 4.38672 9.82031 4.22266C10.6953 4.16797 11.4336 4.00391 12.0078 3.78516C12.3633 3.64844 12.6367 3.48438 12.7734 3.34766C12.8555 3.29297 12.8828 3.23828 12.9102 3.21094C12.9375 3.18359 12.9375 3.18359 12.9375 3.15625C12.9375 3.15625 12.9375 3.15625 12.9102 3.12891C12.8828 3.10156 12.8555 3.04688 12.7734 2.96484C12.6367 2.82812 12.3633 2.69141 12.0078 2.55469C11.2695 2.25391 10.2031 2.0625 9 2.0625C7.76953 2.0625 6.70312 2.25391 5.96484 2.55469C5.60938 2.69141 5.33594 2.82812 5.19922 2.96484C5.11719 3.04688 5.08984 3.10156 5.0625 3.12891C5.0625 3.15625 5.0625 3.15625 5.0625 3.15625ZM1.5625 6.65625C1.5625 6.68359 1.5625 6.68359 1.5625 6.71094C1.58984 6.73828 1.61719 6.79297 1.69922 6.84766C1.83594 6.98438 2.10938 7.14844 2.46484 7.28516C3.20312 7.55859 4.26953 7.75 5.5 7.75C6.70312 7.75 7.76953 7.55859 8.50781 7.28516C8.86328 7.14844 9.13672 6.98438 9.27344 6.84766C9.35547 6.79297 9.38281 6.73828 9.41016 6.71094C9.41016 6.68359 9.4375 6.68359 9.4375 6.65625C9.4375 6.65625 9.4375 6.65625 9.41016 6.62891C9.38281 6.60156 9.35547 6.54688 9.27344 6.46484C9.13672 6.32812 8.86328 6.19141 8.50781 6.05469C7.76953 5.75391 6.70312 5.58984 5.5 5.58984C4.26953 5.58984 3.20312 5.75391 2.46484 6.05469C2.10938 6.19141 1.83594 6.35547 1.69922 6.46484C1.61719 6.54688 1.58984 6.60156 1.5625 6.62891C1.5625 6.65625 1.5625 6.65625 1.5625 6.65625ZM0.25 6.65625C0.25 6.16406 0.496094 5.78125 0.824219 5.50781C1.125 5.20703 1.53516 4.98828 2 4.82422C2.92969 4.46875 4.16016 4.25 5.5 4.25C6.8125 4.25 8.04297 4.46875 8.97266 4.82422C9.4375 4.98828 9.84766 5.20703 10.1484 5.50781C10.4766 5.78125 10.75 6.16406 10.75 6.65625V9.5V12.3438C10.75 12.8359 10.4766 13.2461 10.1484 13.5195C9.84766 13.793 9.4375 14.0391 8.97266 14.2031C8.04297 14.5586 6.8125 14.75 5.5 14.75C4.16016 14.75 2.92969 14.5586 2 14.2031C1.53516 14.0391 1.125 13.8203 0.824219 13.5195C0.496094 13.2461 0.25 12.8359 0.25 12.3438V9.5V6.65625ZM9.4375 9.5V8.32422C9.27344 8.37891 9.13672 8.46094 8.97266 8.51562C8.04297 8.87109 6.8125 9.0625 5.5 9.0625C4.16016 9.0625 2.92969 8.87109 2 8.51562C1.83594 8.46094 1.69922 8.40625 1.5625 8.32422V9.5C1.5625 9.52734 1.5625 9.52734 1.5625 9.55469C1.58984 9.58203 1.61719 9.63672 1.69922 9.69141C1.83594 9.82812 2.10938 9.99219 2.46484 10.1289C3.20312 10.4023 4.26953 10.5938 5.5 10.5938C6.70312 10.5938 7.76953 10.4023 8.50781 10.1289C8.86328 9.99219 9.13672 9.82812 9.27344 9.69141C9.35547 9.63672 9.38281 9.58203 9.41016 9.55469C9.41016 9.52734 9.4375 9.52734 9.4375 9.5ZM2 11.3594C1.83594 11.3047 1.69922 11.25 1.5625 11.168V12.3438C1.5625 12.3438 1.5625 12.3711 1.5625 12.3984C1.58984 12.4258 1.61719 12.4805 1.69922 12.5352C1.83594 12.6719 2.10938 12.8359 2.46484 12.9727C3.20312 13.2461 4.26953 13.4375 5.5 13.4375C6.70312 13.4375 7.76953 13.2461 8.50781 12.9727C8.86328 12.8359 9.13672 12.6719 9.27344 12.5352C9.35547 12.4805 9.38281 12.4258 9.41016 12.3984C9.4375 12.3711 9.4375 12.3438 9.4375 12.3438V11.168C9.27344 11.2227 9.13672 11.3047 8.97266 11.3594C8.04297 11.7148 6.8125 11.9062 5.5 11.9062C4.16016 11.9062 2.92969 11.7148 2 11.3594Z'
                            fill='#37393D'
                          />
                        </svg>
                        <p>{i18n.t(`indicators.sales`)}</p>
                        <div className='d-flex flex-row align-items-center gap-2'>
                          <h4>{toMoney(sales.toFixed(2))}</h4>
                        </div>
                      </div>
                      <div className={styles.cardOrders}>
                        <svg
                          width='18'
                          height='15'
                          viewBox='0 0 18 15'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M16.3945 8.07812L13.3047 11.168C11.7461 12.6992 9.25781 12.6992 7.72656 11.168C6.27734 9.69141 6.19531 7.36719 7.53516 5.80859L7.67188 5.64453C7.91797 5.37109 8.32812 5.34375 8.60156 5.58984C8.875 5.83594 8.90234 6.24609 8.65625 6.51953L8.54688 6.65625C7.61719 7.69531 7.67188 9.25391 8.65625 10.2383C9.66797 11.25 11.3359 11.25 12.375 10.2383L15.4648 7.14844C16.4766 6.10938 16.4766 4.46875 15.4648 3.42969C14.4805 2.47266 12.9219 2.41797 11.8828 3.32031L11.7188 3.45703C11.4453 3.70312 11.0352 3.67578 10.7891 3.40234C10.543 3.12891 10.5703 2.71875 10.8438 2.47266L11.0078 2.33594C12.5664 0.96875 14.918 1.05078 16.3945 2.5C17.9258 4.03125 17.9258 6.51953 16.3945 8.07812ZM2.14844 7.44922L5.26562 4.35938C6.79688 2.82812 9.28516 2.82812 10.8164 4.35938C12.293 5.80859 12.375 8.16016 11.0078 9.71875L10.8438 9.88281C10.625 10.1562 10.1875 10.2109 9.91406 9.96484C9.64062 9.71875 9.61328 9.30859 9.85938 9.03516L10.0234 8.87109C10.9258 7.83203 10.8711 6.27344 9.88672 5.28906C8.875 4.25 7.20703 4.25 6.19531 5.28906L3.07812 8.37891C2.06641 9.41797 2.06641 11.0586 3.07812 12.0977C4.0625 13.0547 5.62109 13.1094 6.66016 12.207L6.82422 12.0703C7.09766 11.8242 7.50781 11.8516 7.75391 12.125C8 12.3984 7.97266 12.8086 7.69922 13.0547L7.53516 13.1914C5.97656 14.5586 3.625 14.4766 2.14844 13.0273C0.617188 11.4961 0.617188 8.98047 2.14844 7.44922Z'
                            fill='#37393D'
                          />
                        </svg>
                        <p>{i18n.t(`indicators.accesses`)}</p>
                        <div className='d-flex flex-row align-items-center gap-2'>
                          <h4>{accesses}</h4>
                        </div>
                      </div>
                      <div className={styles.cardOrders}>
                        <svg
                          width='15'
                          height='13'
                          viewBox='0 0 15 13'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M0.75 1.77344C0.75 1.14453 1.24219 0.625 1.87109 0.625H13.6016C14.2305 0.625 14.75 1.14453 14.75 1.77344C14.75 2.04688 14.6406 2.29297 14.4766 2.48438L9.9375 8.08984V12C9.9375 12.4922 9.52734 12.875 9.03516 12.875C8.84375 12.875 8.65234 12.8203 8.48828 12.6836L5.97266 10.6875C5.69922 10.4688 5.5625 10.168 5.5625 9.83984V8.08984L0.996094 2.48438C0.832031 2.29297 0.75 2.04688 0.75 1.77344ZM2.22656 1.9375L6.71094 7.43359C6.82031 7.57031 6.875 7.70703 6.875 7.84375V9.73047L8.625 11.125V7.84375C8.625 7.70703 8.65234 7.57031 8.76172 7.43359L13.2461 1.9375H2.22656Z'
                            fill='#37393D'
                          />
                        </svg>
                        <p>{i18n.t(`indicators.sales_conversion`)}</p>
                        <div className='d-flex flex-row align-items-center gap-2'>
                          <h4>{conversion}%</h4>
                        </div>
                      </div>
                      <div className={styles.cardOrders}>
                        <svg
                          width='9'
                          height='15'
                          viewBox='0 0 9 15'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M5.46875 1.40625V2.77344C6.20703 2.85547 6.89062 2.99219 7.41016 3.10156C7.76562 3.18359 7.98438 3.53906 7.90234 3.89453C7.82031 4.25 7.46484 4.46875 7.10938 4.38672C6.26172 4.19531 5.03125 3.94922 3.99219 4.05859C3.47266 4.08594 3.0625 4.19531 2.76172 4.38672C2.48828 4.57812 2.26953 4.82422 2.21484 5.23438C2.13281 5.53516 2.1875 5.75391 2.26953 5.89062C2.32422 6.05469 2.48828 6.19141 2.73438 6.35547C3.25391 6.68359 4.01953 6.875 4.94922 7.12109L5.03125 7.14844C5.87891 7.36719 6.83594 7.61328 7.57422 8.05078C7.92969 8.26953 8.28516 8.59766 8.50391 9.03516C8.75 9.47266 8.77734 9.99219 8.69531 10.5391C8.50391 11.5234 7.79297 12.1523 6.91797 12.4805C6.48047 12.6445 5.98828 12.7539 5.46875 12.7812V14.0938C5.46875 14.4766 5.16797 14.75 4.8125 14.75C4.42969 14.75 4.15625 14.4766 4.15625 14.0938V12.7539C4.04688 12.7266 3.96484 12.7266 3.88281 12.6992C3.19922 12.6172 1.99609 12.3438 1.25781 12.0156C0.929688 11.8516 0.765625 11.4688 0.929688 11.1406C1.06641 10.8125 1.44922 10.6484 1.77734 10.8125C2.37891 11.0586 3.44531 11.332 4.04688 11.4141C5.03125 11.5508 5.85156 11.4688 6.45312 11.25C7.02734 11.0312 7.32812 10.7031 7.38281 10.293C7.46484 9.96484 7.41016 9.77344 7.32812 9.63672C7.27344 9.47266 7.10938 9.30859 6.86328 9.17188C6.34375 8.84375 5.57812 8.625 4.64844 8.40625L4.56641 8.37891C3.71875 8.16016 2.76172 7.91406 2.02344 7.47656C1.66797 7.23047 1.3125 6.92969 1.09375 6.49219C0.875 6.02734 0.820312 5.53516 0.929688 4.98828C1.06641 4.19531 1.47656 3.64844 2.05078 3.29297C2.59766 2.9375 3.25391 2.80078 3.88281 2.74609C3.96484 2.71875 4.04688 2.71875 4.15625 2.71875V1.40625C4.15625 1.05078 4.42969 0.75 4.8125 0.75C5.16797 0.75 5.46875 1.05078 5.46875 1.40625Z'
                            fill='#37393D'
                          />
                        </svg>
                        <p>{i18n.t(`indicators.mean_ticket`)}</p>
                        <div className='d-flex flex-row align-items-center gap-2'>
                          <h4>{toMoney(averageTicket.toFixed(2))}</h4>
                        </div>
                      </div>
                      <div className={styles.cardOrders}>
                        <p>{i18n.t(`indicators.carts`)}</p>
                        <div className='d-flex flex-row align-items-center gap-2'>
                          <h4>{toMoney(carts.toFixed(2))}</h4>
                        </div>
                      </div>
                      <div className={styles.cardOrders}>
                        <p>{i18n.t(`indicators.attended_customers`)}</p>
                        <div className='d-flex flex-row align-items-center gap-2'>
                          <h4>{customersReport}</h4>
                        </div>
                      </div>
                      <div className={styles.cardOrders}>
                        <p>{i18n.t(`indicators.active_sellers`)}</p>
                        <div className='d-flex flex-row align-items-center gap-2'>
                          <h4>{activeSellers}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='card card-xxl-stretch' style={{flex: 0.6}}>
              <div className='card-header'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-3 mb-1'>
                    {i18n.t(`indicators.sales_by_category`)}
                  </span>
                </h3>
              </div>
              <div
                className={`d-flex ${
                  salesByCategory.length > 0 ? 'align-items-center' : 'align-items-start'
                } w-100 h-100 p-4`}
              >
                <div className='w-100'>
                  {salesByCategory && salesByCategory.length > 0 ? (
                    <Chart
                      options={{
                        plotOptions: {
                          pie: {
                            dataLabels: {
                              offset: 0,
                            },
                          },
                        },
                        labels: salesByCategory.map((sale) => sale.label),
                        legend: {
                          show: false,
                          horizontalAlign: 'right',
                          formatter: function (legendName, opts) {
                            return `${legendName}: R$${opts.w.config.series[opts.seriesIndex]}`
                          },
                        },
                        theme: {
                          monochrome: {
                            enabled: true,
                            color: '#CA498C',
                            shadeTo: 'light',
                            shadeIntensity: 0.65,
                          },
                        },

                        dataLabels: {
                          style: {
                            colors: ['#FFF'],
                            fontWeight: 'bold',
                          },
                          dropShadow: {
                            enabled: true,
                            opacity: 1,
                          },
                          formatter: function (val, opts) {
                            return `${opts.w.config.labels[opts.seriesIndex]}: ${floatToPrice(
                              opts.w.config.series[opts.seriesIndex]
                            )}`
                          },
                        },
                        tooltip: {
                          y: {
                            formatter: function (val, opts) {
                              return floatToPrice(opts.config.series[opts.seriesIndex])
                            },
                          },
                        },
                      }}
                      series={salesByCategory.map((sale) => sale.value)}
                      type='pie'
                      height={320}
                    />
                  ) : (
                    <p>Resultados não encontrados</p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-between gap-5'>
            <div className='card card-xxl-stretch pb-4 w-100 pt-4'>
              <div className='card-header'>
                <h3
                  className='card-title align-items-start flex-column'
                  style={{paddingBottom: '6em'}}
                >
                  <span className='card-label fw-bolder fs-3'>
                    {i18n.t(`indicators.revenue_store`)}
                  </span>
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    placeholder='Selecione um tipo'
                    label={i18n.t(`indicators.select_view`)}
                    options={[
                      {
                        select: 'Diário',
                        value: 'daily',
                      },
                      {
                        select: 'Mensal',
                        value: 'monthly',
                      },
                    ]}
                    value={modeViewSale}
                    change={(value: 'daily' | 'monthly') => setModeViewSale(value)}
                  />
                </h3>
              </div>
              <div className='d-flex align-items-center w-100 h-100 p-4'>
                <div className='w-100'>
                  <Chart
                    options={{
                      ...optionsChart,
                      xaxis: {
                        categories: verifyModeViewLabels(salesSeller, modeViewSale),
                      },
                    }}
                    series={[
                      {
                        name: 'Vendas',
                        data: verifyModeViewValues(salesSeller, modeViewSale),
                      },
                    ]}
                    type='line'
                    height={220}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-between gap-5'>
            <div className='card card-xxl-stretch pb-4 w-100 pt-4'>
              <div className='card-header'>
                <h3
                  className='card-title align-items-start flex-column'
                  style={{paddingBottom: '6em'}}
                >
                  <span className='card-label fw-bolder fs-3'>
                    {i18n.t(`indicators.comparative_sales_by_seller`)}
                  </span>
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    placeholder='Selecione um tipo'
                    label={i18n.t(`indicators.select_view`)}
                    options={[
                      {
                        select: 'Diário',
                        value: 'daily',
                      },
                      {
                        select: 'Mensal',
                        value: 'monthly',
                      },
                    ]}
                    value={modeViewSalesBySeller}
                    change={(value: 'daily' | 'monthly') => setModeViewSalesBySeller(value)}
                  />
                </h3>
              </div>
              <div className='d-flex align-items-center w-100 h-100 p-4'>
                <div className='w-100'>
                  <Chart
                    options={{
                      ...optionsChart,
                      xaxis: {
                        categories: verifyModeViewLabels(
                          salesBySeller.length > 0 ? salesBySeller[0] : {labels: [], values: []},
                          modeViewSalesBySeller
                        ),
                      },
                    }}
                    series={salesBySeller.map((sale) => ({
                      name: sale.title,
                      data: verifyModeViewValues(sale, modeViewSalesBySeller),
                    }))}
                    type='line'
                    height={220}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-between gap-5'>
            <div className='card card-xxl-stretch pb-4 w-100 pt-4'>
              <div className='card-header'>
                <h3
                  className='card-title align-items-start flex-column'
                  style={{paddingBottom: '6em'}}
                >
                  <span className='card-label fw-bolder fs-3'>
                    {i18n.t(`indicators.comparative_sales_by_channel`)}
                  </span>
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    placeholder='Selecione um tipo'
                    label={i18n.t(`indicators.select_view`)}
                    options={[
                      {
                        select: 'Diário',
                        value: 'daily',
                      },
                      {
                        select: 'Mensal',
                        value: 'monthly',
                      },
                    ]}
                    value={modeViewSaleCart}
                    change={(value: 'daily' | 'monthly') => setModeViewSaleCart(value)}
                  />
                </h3>
              </div>
              <div className='d-flex align-items-center w-100 h-100 p-4'>
                <div className='w-100'>
                  <Chart
                    options={{
                      ...optionsChart,
                      xaxis: {
                        categories: verifyModeViewLabels(salesSellerCart, modeViewSaleCart),
                      },
                    }}
                    series={[
                      {
                        name: 'Carrinho gravado',
                        data: verifyModeViewValues(salesSellerCart, modeViewSaleCart),
                      },
                      {
                        name: 'Link do vendedor',
                        data: verifyModeViewValues(salesSellerLink, modeViewSaleCart),
                      },
                    ]}
                    type='line'
                    height={220}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-between gap-5'>
            <div className='card card-xxl-stretch pb-4 w-100'>
              <div className='card-header'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-3 mb-1'>
                    {i18n.t(`indicators.comparative_by_seller`)}
                  </span>
                </h3>
              </div>
              <div className={`d-flex flex-column ${styles.tableSeller}`}>
                {salesByCustomer.length > 0 ? (
                  <>
                    <div className={`w-100 ${styles.gridSeller}`}>
                      <b>Cliente</b>
                      <b>Pedidos</b>
                      <b>Taxa de conversão</b>
                      <b>Faturamento</b>
                    </div>
                    {salesByCustomer.map((sale) => (
                      <div className={`w-100 ${styles.gridSeller}`}>
                        <p>
                          {sale.idCustomer} {sale.customerName}
                        </p>
                        <p>{sale.orders}</p>
                        <p>{calcPercent(parseInt(sale.orders), parseInt(sale.carts))}%</p>
                        <p>{toMoney(parseFloat(sale.total).toFixed(2))}</p>
                      </div>
                    ))}
                    <div className={`w-100 ${styles.gridSeller}`}>
                      <b>Total</b>
                      <p>{orders}</p>
                      <p>{conversion}%</p>
                      <p>{toMoney(sales.toFixed(2))}</p>
                    </div>
                  </>
                ) : (
                  <p>Resultados não encontrados</p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const GerenteLojaIndicadores: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Indicadores', path: 'indicadores/seller_access', isActive: false},
          {
            title: i18n.t(`indicators.sellerAccess`),
            path: 'indicadores/summary_access',
            isActive: true,
          },
        ]}
      >
        {i18n.t(`indicators.sellerAccess`)}
      </PageTitle>
      <GerenteLojaContent />
    </>
  )
}

export {GerenteLojaIndicadores}
